/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Regionalpricing_Price1Inputs */

const id_components_regionalpricing_price1 = /** @type {(inputs: Components_Regionalpricing_Price1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Harga`)
};

const ms_components_regionalpricing_price1 = /** @type {(inputs: Components_Regionalpricing_Price1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Harga`)
};

const da_components_regionalpricing_price1 = /** @type {(inputs: Components_Regionalpricing_Price1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pris`)
};

const de_components_regionalpricing_price1 = /** @type {(inputs: Components_Regionalpricing_Price1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preis`)
};

const en_us2_components_regionalpricing_price1 = /** @type {(inputs: Components_Regionalpricing_Price1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Price`)
};

const es_es2_components_regionalpricing_price1 = /** @type {(inputs: Components_Regionalpricing_Price1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Precio`)
};

const es_mx2_components_regionalpricing_price1 = /** @type {(inputs: Components_Regionalpricing_Price1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Precio`)
};

const fil_components_regionalpricing_price1 = /** @type {(inputs: Components_Regionalpricing_Price1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Presyo`)
};

const fr_components_regionalpricing_price1 = /** @type {(inputs: Components_Regionalpricing_Price1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prix`)
};

const it_components_regionalpricing_price1 = /** @type {(inputs: Components_Regionalpricing_Price1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prezzo`)
};

const hu_components_regionalpricing_price1 = /** @type {(inputs: Components_Regionalpricing_Price1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ár`)
};

const nl_components_regionalpricing_price1 = /** @type {(inputs: Components_Regionalpricing_Price1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prijs`)
};

const no_components_regionalpricing_price1 = /** @type {(inputs: Components_Regionalpricing_Price1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pris`)
};

const pl_components_regionalpricing_price1 = /** @type {(inputs: Components_Regionalpricing_Price1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cena`)
};

const pt_br2_components_regionalpricing_price1 = /** @type {(inputs: Components_Regionalpricing_Price1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Price`)
};

const pt_components_regionalpricing_price1 = /** @type {(inputs: Components_Regionalpricing_Price1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preço`)
};

const ro_components_regionalpricing_price1 = /** @type {(inputs: Components_Regionalpricing_Price1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preț`)
};

const fi_components_regionalpricing_price1 = /** @type {(inputs: Components_Regionalpricing_Price1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hinta`)
};

const sv_components_regionalpricing_price1 = /** @type {(inputs: Components_Regionalpricing_Price1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pris`)
};

const vi_components_regionalpricing_price1 = /** @type {(inputs: Components_Regionalpricing_Price1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giá`)
};

const tr_components_regionalpricing_price1 = /** @type {(inputs: Components_Regionalpricing_Price1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fiyat`)
};

const cs_components_regionalpricing_price1 = /** @type {(inputs: Components_Regionalpricing_Price1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cena`)
};

const bg_components_regionalpricing_price1 = /** @type {(inputs: Components_Regionalpricing_Price1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Цена`)
};

const ru_components_regionalpricing_price1 = /** @type {(inputs: Components_Regionalpricing_Price1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Цена`)
};

const uk_components_regionalpricing_price1 = /** @type {(inputs: Components_Regionalpricing_Price1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ціна`)
};

const ar_components_regionalpricing_price1 = /** @type {(inputs: Components_Regionalpricing_Price1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`السعر`)
};

const hi_components_regionalpricing_price1 = /** @type {(inputs: Components_Regionalpricing_Price1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कीमत`)
};

const th_components_regionalpricing_price1 = /** @type {(inputs: Components_Regionalpricing_Price1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ราคา`)
};

const ja_components_regionalpricing_price1 = /** @type {(inputs: Components_Regionalpricing_Price1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`価格`)
};

const zh_cn2_components_regionalpricing_price1 = /** @type {(inputs: Components_Regionalpricing_Price1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Price`)
};

const zh_hant1_components_regionalpricing_price1 = /** @type {(inputs: Components_Regionalpricing_Price1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Price`)
};

const ko_components_regionalpricing_price1 = /** @type {(inputs: Components_Regionalpricing_Price1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Price`)
};

/**
* | output |
* | --- |
* | "Price" |
*
* @param {Components_Regionalpricing_Price1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_regionalpricing_price1 = /** @type {((inputs?: Components_Regionalpricing_Price1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Regionalpricing_Price1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_regionalpricing_price1(inputs)
	if (locale === "ms") return ms_components_regionalpricing_price1(inputs)
	if (locale === "da") return da_components_regionalpricing_price1(inputs)
	if (locale === "de") return de_components_regionalpricing_price1(inputs)
	if (locale === "en-US") return en_us2_components_regionalpricing_price1(inputs)
	if (locale === "es-ES") return es_es2_components_regionalpricing_price1(inputs)
	if (locale === "es-MX") return es_mx2_components_regionalpricing_price1(inputs)
	if (locale === "fil") return fil_components_regionalpricing_price1(inputs)
	if (locale === "fr") return fr_components_regionalpricing_price1(inputs)
	if (locale === "it") return it_components_regionalpricing_price1(inputs)
	if (locale === "hu") return hu_components_regionalpricing_price1(inputs)
	if (locale === "nl") return nl_components_regionalpricing_price1(inputs)
	if (locale === "no") return no_components_regionalpricing_price1(inputs)
	if (locale === "pl") return pl_components_regionalpricing_price1(inputs)
	if (locale === "pt-BR") return pt_br2_components_regionalpricing_price1(inputs)
	if (locale === "pt") return pt_components_regionalpricing_price1(inputs)
	if (locale === "ro") return ro_components_regionalpricing_price1(inputs)
	if (locale === "fi") return fi_components_regionalpricing_price1(inputs)
	if (locale === "sv") return sv_components_regionalpricing_price1(inputs)
	if (locale === "vi") return vi_components_regionalpricing_price1(inputs)
	if (locale === "tr") return tr_components_regionalpricing_price1(inputs)
	if (locale === "cs") return cs_components_regionalpricing_price1(inputs)
	if (locale === "bg") return bg_components_regionalpricing_price1(inputs)
	if (locale === "ru") return ru_components_regionalpricing_price1(inputs)
	if (locale === "uk") return uk_components_regionalpricing_price1(inputs)
	if (locale === "ar") return ar_components_regionalpricing_price1(inputs)
	if (locale === "hi") return hi_components_regionalpricing_price1(inputs)
	if (locale === "th") return th_components_regionalpricing_price1(inputs)
	if (locale === "ja") return ja_components_regionalpricing_price1(inputs)
	if (locale === "zh-CN") return zh_cn2_components_regionalpricing_price1(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_regionalpricing_price1(inputs)
	return ko_components_regionalpricing_price1(inputs)
});
export { components_regionalpricing_price1 as "components.regionalPricing.price" }